@if (question) {
    <div
            [ngClass]="isMobileView && isCurrentQuestion && !isLocked() && !question.isCollapsed ?'min-h-[calc(100svh_-_215px)] mt-1':''">
        <div #questionElem class="mb-2.5 w-fit" [ngClass]="isMobileView?'contents':'flex flex-wrap gap-2.5'"
             [class.hover:cursor-pointer]="!isLocked()" (click)="toggleQuestionVisibility()">
            @if (question.isChecked) {
                <bizz-icon iconName="circle-check" class="ml sm:size6 size-7 text-green-500"
                           [class.float-left]="isMobileView"
                           [class.mr-2.5]="isMobileView"></bizz-icon>
            } @else {
                <div class="flex size-7 shrink-0 items-center justify-center rounded-full bg-blue-500 text-sm font-semibold text-white sm:size-6"
                     [class.!text-[10px]]="questionNumber>99" [class.float-left]="isMobileView"
                     [class.mr-2.5]="isMobileView">
                    {{ questionNumber }}
                </div>
            }
            <div>
            <span class="font-semibold text-default align-middle [&>:first-child]:contents sm:text-sm"
                  [ngClass]="isMobileView?'text-base leading-7':'text-xl'"
                  [innerHTML]="question.Question | safe : 'html'"></span>
                @if (isRequired()) {
                    <span class="relative -top-1 m-1 h-5 text-xl leading-tight text-red-500">*</span>
                }
                @if (question.ExtraInfo) {
                    <bizz-icon class="ml-1 inline-block h-5 w-5 text-list-row-action hover:cursor-pointer sm:h-3 sm:w-3"
                               [class.ml-2]="isMobileView" #anchor (touchend)="showPopup()"
                               (mouseenter)="onAnchorMouseEnter()"
                               (mouseleave)="onAnchorMouseLeave()" iconName="circle-info">
                    </bizz-icon>
                }
            </div>
        </div>

        @if ((isCurrentQuestion || isLocked()) && !question.isCollapsed) {
            <div class="sm:ml-9" [class.mt-2.5]="isMobileView">
                @if (question.Description.length) {
                    <p class="text-xs text-default" [innerHTML]="question.Description | safe : 'html'"></p>
                }
                <div class="flex flex-wrap gap-x-6 gap-y-5 pt-2" [class.flex-col]="isMobileView">
                    <bizz-checklist-answer-types class="xl:grow-0"
                                                 [class.flex-grow]="question.ResultClass.ResultClassType == ChecklistAnswerClassType.Html"
                                                 [question]="question" [isLocked]="isLocked()"
                                                 [isMobileView]="isMobileView"
                                                 (questionChange)="dispatchChange($event)"
                                                 (resetButtonsOptions)="resetButtonsOptions()"
                                                 [isDarkTheme]="isDarkTheme"></bizz-checklist-answer-types>

                    <div class="flex flex-grow gap-2.5">
                        <button type="button"
                                class="default flex h-10 w-10 items-center justify-center rounded-full hover:cursor-pointer sm:h-8 sm:w-8"
                                [class.active]="question.UserAnswer?.Answer?.RemarksRequired || showRemarks || question.UserAnswer?.Remarks?.length"
                                [class.hover:cursor-not-allowed]="question.UserAnswer?.Answer?.RemarksRequired"
                                [disabled]="isLocked()" (click)="toggleRemarks()">
                            <bizz-icon iconName="comment-lines"
                                       class="min-h-[16px] min-w-[16px] text-default"></bizz-icon>
                        </button>
                        <button type="button"
                                class="default flex h-10 w-10 items-center justify-center rounded-full hover:cursor-pointer sm:h-8 sm:w-8"
                                [class.active]="question.UserAnswer?.Answer?.AttachmentRequired || showAttachments || question.UserAnswer?.Attachments?.length"
                                [class.hover:cursor-not-allowed]="question.UserAnswer?.Answer?.AttachmentRequired"
                                (click)="toggleAttachments()">
                            <bizz-icon iconName="paperclip" class="min-h-[16px] min-w-[16px] text-default"></bizz-icon>
                        </button>
                    </div>


                </div>
                @if (question.UserAnswer.Answer?.AttachmentRequired || question.UserAnswer.Answer?.RemarksRequired ||
                question.UserAnswer.Remarks ||
                showAttachments || showRemarks) {
                    <div class="flex w-full gap-5 pt-3" [class.flex-col]="isMobileView">
                        @if (question.AttachmentAndRemarksRequiredSettings.IsRemarkRequired ||
                        question.UserAnswer.Remarks ||
                        showRemarks) {
                            <div class="flex w-full flex-col gap-y-2.5">
                                <label class="flex gap-1 text-sm font-semibold">
                                    <span class="flex items-center">{{ 'Remarks' | translate }}</span>
                                    @if (question.AttachmentAndRemarksRequiredSettings.IsRemarkRequired ||
                                    question.UserAnswer.Answer?.RemarksRequired &&
                                    question.UserAnswer?.Answer?.Outcome) {
                                        <span class="-top-0.5 h-5 text-xl leading-4 text-red-400">*</span>
                                    }
                                </label>
                                <bizz-editor class="grid" [disabled]="isLocked()"
                                             [minimumHeight]="isLocked() ? 45: 200"
                                             [value]="question.UserAnswer.Remarks ??''"
                                             (valueChange)="setRemarks($event)"></bizz-editor>
                            </div>
                        }
                        @if (question.UserAnswer.Answer?.AttachmentRequired || showAttachments) {
                            <div class="flex w-full flex-col gap-y-2.5">
                                <label class="flex gap-1 text-sm font-semibold">
                                    <span class="flex items-center">{{ 'Attachments' | translate }}</span>
                                    @if (question.AttachmentAndRemarksRequiredSettings.IsAttachmentRequired ||
                                    question.UserAnswer.Answer?.AttachmentRequired) {
                                        <span class="-top-0.5 h-5 text-xl leading-4 text-red-400">*</span>
                                    }
                                </label>
                                <bizz-mailing-attachments-upload mode="checklists" [readonly]="isLocked()"
                                                                 [mediaId]="mediaIds"
                                                                 [currentAttachments]="attachments"
                                                                 (fullAttachmentsChanged)="setAttachments($event)"
                                                                 (downloadAttachmentChanged)="downloadAttachment($event)"
                                ></bizz-mailing-attachments-upload>
                            </div>
                        }
                    </div>
                }

            </div>
        }
    </div>

}

<ng-template #readmorePopupTemplateRef>
    <div class="bizz-popup-content readmore max-w-screen-sm text-xs md:max-w-[800px]" (touchend)="hidePopup()"
         (mouseenter)="onPopupMouseEnter()" (mouseleave)="onPopupMouseLeave()">
        <div class="border-button px-4 py-3 text-sm sm:text-xs">
            <div class="inline-block max-h-[calc(100svh_-_60px)] max-w-[calc(100vw_-_48px)] overflow-y-auto text-default *:!text-default sm:max-h-[550px] sm:w-fit sm:min-w-[352px] sm:max-w-[750px]"
                 [innerHTML]="question.ExtraInfo | safe: 'html'">
            </div>
        </div>
    </div>
</ng-template>